import "./App.css";
import { Routes, Route, Outlet } from "react-router-dom";
import ReservationForm from "./Components/ReservationForm";
import ConfirmationPage from "./Components/ConfirmationPage";
import LpCarousel from "./Components/LpCarousel";

function Layout() {
  return (
    <div className="app-root">
      <main className="app-main">
        <Outlet />
      </main>
      <LpCarousel />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<ReservationForm />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
      </Route>
    </Routes>
  );
}
